var _path, _path2, _path3, _path4, _path5, _path6, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAirbusLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 72,
    viewBox: "0 0 110 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 26,
    width: 110,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.7026 32.9588C50.7026 29.2417 48.264 26.4165 43.2384 26.4165H33.1276V45.9541H37.8857V30.639H43.2681C45.2607 30.639 45.9739 31.7694 45.9739 33.0776C45.9739 34.4159 45.2306 35.5163 43.2381 35.5163H38.6288L45.1711 45.9541H50.5835C50.5835 45.9541 46.1226 38.9359 46.1526 38.9359C48.9185 38.2819 50.7026 36.3489 50.7026 32.9588Z",
    fill: "#00205B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9159 26.4165H25.1577V45.9543H29.9159V26.4165Z",
    fill: "#00205B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.96219 26.4165L0 45.9541H5.35261L6.96634 42.6831H14.9875L12.9953 38.5791H8.99115L11.9542 32.5723H12.014L18.6751 45.9541H24.1469L14.1847 26.4165H9.96219Z",
    fill: "#00205B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0705 35.8138C69.5874 34.9808 70.3903 33.6428 70.3903 31.6801C70.3903 28.5279 68.0409 26.4165 64.0859 26.4165H52.9633V45.9541H64.532C68.5761 45.9541 71.2229 43.7831 71.2229 40.4823C71.2226 38.1929 69.9442 36.468 68.0705 35.8138ZM57.722 30.5499H64.0859C65.0376 30.5499 65.781 31.2932 65.781 32.2748C65.781 33.2563 65.0377 33.9996 64.0559 33.9996H57.7217V30.5499H57.722ZM64.2045 41.8501H57.7217V37.8653H64.2045C65.3644 37.8653 66.2566 38.6982 66.2566 39.8281C66.2568 40.9877 65.3644 41.8501 64.2045 41.8501Z",
    fill: "#00205B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2401 37.3302C86.2401 40.2957 84.872 41.9395 82.1662 41.9395C79.4899 41.9395 78.1219 40.2957 78.1219 37.3302V26.4165H73.2451V36.9734C73.2451 43.0103 76.4271 46.3707 82.1662 46.3707C87.9054 46.3707 91.1171 43.0103 91.1171 36.9734V26.4165H86.2401V37.3302Z",
    fill: "#00205B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M103.815 34.1781C99.2978 33.0783 98.3135 32.9732 98.3135 31.6799C98.3135 30.6793 99.4434 30.193 101.347 30.193C103.874 30.193 106.566 30.8271 108.097 31.7692L109.614 27.7844C107.651 26.7436 104.766 26 101.406 26C96.3802 26 93.555 28.4982 93.555 31.8583C93.555 35.4739 95.6653 36.9429 100.514 37.9842C104.288 38.8163 105.093 39.3355 105.093 40.3928C105.093 41.5414 104.052 42.0584 102.001 42.0584C99.0268 42.0584 96.3353 41.336 94.1795 40.1552L92.7224 44.3184C95.0717 45.5673 98.5807 46.3705 102.119 46.3705C107.056 46.3705 110 44.0804 110 40.2442C110 37.1665 108.009 35.1894 103.815 34.1781Z",
    fill: "#00205B"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 72,
    fill: "#1B2738"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirbusLogo);
export default __webpack_public_path__ + "static/media/airbus_logo.9c79bdca6b2e42376b8b33859bae3474.svg";
export { ForwardRef as ReactComponent };